import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import {Switch, BrowserRouter as Router, Route } from 'react-router-dom';

import favicon from './favicon.ico';

ReactDOM.render(
  <Router>
      <App/>
  </Router>,
  document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js